import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../../_metronic/partials'
import {useAuth} from '../../../auth'
import {getAccessRequest, updateAccessRequest} from '../../core/_requests'
import {toast} from 'react-toastify'
import {NoDataPage} from '../../../resources/components/NoDataPage'
import {Loader} from '../../../widgets/components/General/Loader'
import {DeleteClassificationModal} from '../RecordsClassifications/DeleteClassificationModal'

const Actions = ({recordId}: {recordId: string | undefined}) => {
  const {companyId} = useAuth()
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(false)
  const [handleResponseLoader, setHandleResponseLoader] = useState<boolean>(false)
  const [requestId, setRequestId] = useState('')
  const [action, setAction] = useState<string>('')
  const [showDeleteModal, setDeleteShowModal] = useState<boolean>(false)
  const getAllRequests = async () => {
    if (!recordId || !companyId) return
    try {
      setLoading(true)
      const {
        data: {success, data},
      } = await getAccessRequest(companyId, recordId)
      if (success) {
        setNotifications(data)
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (recordId) getAllRequests()
  }, [recordId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleResponse = async () => {
    setHandleResponseLoader(true)
    if (!companyId) return
    try {
      const {
        data: {success, error},
      } = await updateAccessRequest(companyId, requestId, action)
      if (success) {
        getAllRequests()
      } else {
        toast.error(error[0])
      }
    } catch (err) {
    } finally {
      setDeleteShowModal(false)
      setRequestId('')
      setHandleResponseLoader(false)
    }
  }
  return (
    <div className='p-4 bg-white rounded d-flex gap-4 flex-column'>
      <h1 className='font-size-16'>{formatMessage({id: 'Actions'})}</h1>

      {loading ? (
        <div className='my-5 mx-6'>
          <Loader />
        </div>
      ) : notifications.length === 0 ? (
        <NoDataPage />
      ) : (
        <>
          {notifications.map((notification: any, index) => (
            <div
              key={index}
              className='bg-light border rounded py-4 px-2 d-flex justify-content-between align-items-center'
            >
              <h1 className='font-size-13 fw-semibold m-0'>
                {notification.user.firstName +
                  ' ' +
                  notification.user.lastName +
                  ' want to ' +
                  notification.type +
                  ' this file'}
              </h1>
              <div className='d-flex gap-2'>
                {notification?.action === 'Pending' && (
                  <>
                    <button
                      className='btn text-primary border border-primary py-2 font-size-13 fw-normal'
                      style={
                        mode === 'dark' ? {background: 'transparent'} : {background: '#F0F4FF'}
                      }
                      onClick={() => {
                        setDeleteShowModal(true)
                        setAction('Accept')
                        setRequestId(notification.requestAccessId)
                      }}
                    >
                      {formatMessage({id: 'Approve'})}
                    </button>

                    <button
                      className='btn text-danger border border-danger py-2 font-size-13 fw-normal'
                      style={
                        mode === 'dark' ? {background: 'transparent'} : {background: '#FFF0F0'}
                      }
                      onClick={() => {
                        setDeleteShowModal(true)
                        setAction('Reject')
                        setRequestId(notification.requestAccessId)
                      }}
                    >
                      {formatMessage({id: 'Deny'})}
                    </button>
                  </>
                )}
                {notification?.action === 'Accept' && (
                  <div className='badge p-4 py-3 bg-success rounded-pill font-size-13 fw-normal border text-white'>
                    <i className='fa-solid fa-check me-2 text-white'></i>
                    {formatMessage({id: 'Approved'})}
                  </div>
                )}
                {notification?.action === 'Reject' && (
                  <div className='badge p-4 py-3 bg-danger rounded-pill font-size-13 fw-normal border text-white'>
                    <i className='fa-solid fa-xmark me-2 text-white'></i>
                    {formatMessage({id: 'Denied'})}
                  </div>
                )}
              </div>
            </div>
          ))}
        </>
      )}
      <DeleteClassificationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={action === 'Accept' ? 'Approve Request' : 'Reject Request'}
        description={`Are You sure you want to ${
          action === 'Accept' ? 'approve' : 'deny'
        }  this request?`}
        handleDelete={handleResponse}
        warningText={
          action === 'Reject'
            ? 'After rejection, the user will not be able to send a request again'
            : ''
        }
        deleteLoading={handleResponseLoader}
        action={action}
      />
    </div>
  )
}

export default Actions
